import { createApi } from "@reduxjs/toolkit/query/react";
import {
    createBaseQueries,
    EXTERNAL_URL,
    transformErrorResponse,
    transformSuccessResponse,
    transformRequest,
} from "@/services";

const { rawExternalApiBaseQuery: contactUpdateAPIBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

// Student mobile number / email address update — OTP based (used by the Edit Profile page)
export const contactUpdateAPI = createApi({
    reducerPath: 'contactUpdateAPI',
    baseQuery: contactUpdateAPIBaseQuery,
    endpoints: (builder) => ({

        // POST — send OTP to the new email address (body: { oldEmail?, email })
        sendUpdateEmailOtp: builder.mutation({
            query: ({ skipErrorToast, ...requestData }) => ({
                url: `/auth/student/update-email/send-otp`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),

        // POST — send OTP to the new mobile number (body: { oldContact?, contact })
        sendUpdateContactOtp: builder.mutation({
            query: ({ skipErrorToast, ...requestData }) => ({
                url: `/auth/student/update-contact/send-otp`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),

        // POST — verify OTP and update the value (body: { type: "updateEmail" | "updateContact", otp })
        verifyUpdateOtp: builder.mutation({
            query: ({ skipErrorToast, ...requestData }) => ({
                url: `/auth/student/verify-otp`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),
    }),
});

export const {
    useSendUpdateEmailOtpMutation,
    useSendUpdateContactOtpMutation,
    useVerifyUpdateOtpMutation,
} = contactUpdateAPI;

export default contactUpdateAPI;
